import firebase from "firebase/compat/app";

export const setCurrentChallengeToOnGoing = (slugToUpdate) => {
  firebase.firestore().collection("challenges").doc(slugToUpdate).update({
    status: "ongoing",
  });
};
